export default __webpack_public_path__ + "static/media/arena_13.d9a1f617.jpeg";